"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkAssertions = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const create_bulk_assertions_mutation_1 = require("../create-bulk-assertions.mutation");
/**
 * @deprecated Use `usePromisedBulkAssertions` for a promise-based API without callbacks.
 */
const useBulkAssertions = ({ catalogId, onCompleted, onError: onErrorCallback, }) => {
    const [createBulkAssertions] = (0, react_2.useMutation)(create_bulk_assertions_mutation_1.CREATE_BULK_ASSERTIONS);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const handleError = (0, react_1.useCallback)((errorMessage) => {
        setIsLoading(false);
        setError(errorMessage);
        onErrorCallback === null || onErrorCallback === void 0 ? void 0 : onErrorCallback(errorMessage);
    }, [onErrorCallback]);
    const addBulkAssertions = (0, react_1.useCallback)((assertions, expectedMatchedProductCount) => {
        setIsLoading(true);
        setError(null);
        void createBulkAssertions({
            fetchPolicy: 'no-cache',
            variables: {
                batchAssertions: Object.assign({ catalogId, clientMutationId: '', batches: assertions }, (expectedMatchedProductCount !== undefined && { expectedMatchedProductCount })),
            },
            onError: (error) => handleError(error.message),
            onCompleted: (data) => {
                var _a, _b, _c, _d, _e, _f;
                setIsLoading(false);
                if ((_a = data === null || data === void 0 ? void 0 : data.productBatchAssertions) === null || _a === void 0 ? void 0 : _a.error) {
                    handleError((_b = data === null || data === void 0 ? void 0 : data.productBatchAssertions) === null || _b === void 0 ? void 0 : _b.error);
                }
                else {
                    onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted({
                        selectedNodeTitle: (_c = assertions[0].categories) === null || _c === void 0 ? void 0 : _c[0].category,
                        productsCount: (_f = (_e = (_d = assertions[0].filter) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.in) === null || _f === void 0 ? void 0 : _f.length,
                    });
                }
            },
        });
    }, [createBulkAssertions, handleError, onCompleted, catalogId]);
    return {
        isLoading,
        error,
        addBulkAssertions,
    };
};
exports.useBulkAssertions = useBulkAssertions;
